import _ from 'lodash';
import { productAlias } from './productAlias';

export function callOffDescription(callOff: any): string | undefined {
  if(!callOff) return;
  let callOffDescription = `Calloff# ${callOff._id}`;
  if(callOff.quotationId) {
    callOffDescription = `${callOffDescription} / SO# ${callOff.quotationId}`;
  }
  if(callOff.customerPO) {
    callOffDescription = `${callOffDescription} / PO# ${callOff.customerPO}`;
  }
  callOffDescription = `${callOffDescription} / ${productAlias(callOff.product)}`;
  const sellingUnit = _.get(callOff, 'unit.unit2', '');
  if(sellingUnit) {
    callOffDescription = `${callOffDescription} / ${callOff.quantity} ${sellingUnit}(s)`;
  }
  if(callOff.FOC) {
    callOffDescription = `${callOffDescription} [+${callOff.FOC} FOC]`;

  }
  return callOffDescription;
}